<!-- **
  * rateFlag:false
  *     name
  *  value unit
  *    
  * rateFlag:true
  *
  * name/nametotal
  * value/valuetotal
  *   
* -->
<template>
    <div v-if="listData.length > 0" :class="classObject">
        <div :style="{ width: listData.length === 1 ? '100%' : '' }" v-for="(v, i) in listData" :key="i">
            <div class="firstDiv">
                <div v-if="v.rateFlag">
                    <span>{{ `${v.name}/${v.nameTotal}` }}</span>
                </div>
                <div v-else>
                    <span v-if="combineNameUnit">{{ `${v.name}${!!v?.unit ? `(${v.unit})` : ""}` }}</span>
                    <span v-else>{{ v.name }}</span>
                </div>
            </div>
            <div class="secondDiv">
                <div v-if="v.rateFlag">
                    <span :title=v.value class="highlight">{{ numberToCurrencyNo(v.value) }}</span>
                    <span :title=v.valueTotal class="highlight">/{{ numberToCurrencyNo(v.valueTotal) }}</span>
                </div>
                <div v-else>
                    <span :title=v.value class="highlight">{{ numberToCurrencyNo(v.value) }}</span>
                    <span v-if="!!v.unit && !combineNameUnit">{{ v.unit }}</span>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
const classNames = require('classnames')
import { numberToCurrencyNo } from "@/assets/js/utils";
export default {
    name: "HeadTips",
    props: {
        listData: {
            type: Array,
            default: () => []
        },
        twoLine: {
            type: Boolean,
            default: false,
        },
        className: {
            type: String,
            default: ""
        },
        combineNameUnit: {
            type: Boolean,
            default: false
        },
        nameUp: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            listColor: [
                "#279fff",
                "#29c444",
                "#fecc2b",
                "#7472fc",
                "#279fff",
                "#29c444",
                "#fecc2b",
            ],
            value: false,
        };
    },
    computed: {
        classObject: function () {
            return classNames({
                'headTips': true,
                'twoLine': this.twoLine,
                [this.className]: !!this.className,
            })
        }
    },
    methods: {
        numberToCurrencyNo
    },
};
</script>
  
<style lang="scss" scoped>
.headTips {
    width: 100%;
    height: 100%;
    @include setFlexBetween;
    color: #FFFFFF;

    &>div {
        @include setFlexColumn;
        width: 30%;
        height: 100%;
        align-items: center;
        justify-content: center;

        .firstDiv {}

        .secondDiv {
            margin-top: 2px;
            font-size: 14px;
            min-height: 25px;

            .highlight {
                color: #16E9F4;
                font-weight: bold;
                font-size: 22px;
            }

            .bold {
                font-weight: bold;
                font-size: 26px;
            }
        }
    }
}

.twoLine {
    flex-wrap: wrap;

    &>div {
        height: 50%;

        .secondDiv {
            font-size: 14px;
            min-height: 25px;

            .highlight {
                color: #16E9F4;
                font-weight: bold;
                font-size: 22px;
            }

            .bold {
                font-weight: bold;
                font-size: 22px;
            }
        }
    }
}
</style>